module.exports = __webpack_public_path__ + "static/gallery_west_street_3-b5d9325b41599c724505eecd62b5b206.jpg";